namespace TabAurous.OMS {
    export interface ProcessInspectionForm {
        Parameter: Serenity.StringEditor;
        Value: Serenity.StringEditor;
        IsNumeric: Serenity.BooleanEditor;
        Min: Serenity.DecimalEditor;
        Max: Serenity.DecimalEditor;
    }

    export class ProcessInspectionForm extends Serenity.PrefixedContext {
        static formKey = 'OMS.ProcessInspection';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!ProcessInspectionForm.init)  {
                ProcessInspectionForm.init = true;

                var s = Serenity;
                var w0 = s.StringEditor;
                var w1 = s.BooleanEditor;
                var w2 = s.DecimalEditor;

                Q.initFormType(ProcessInspectionForm, [
                    'Parameter', w0,
                    'Value', w0,
                    'IsNumeric', w1,
                    'Min', w2,
                    'Max', w2
                ]);
            }
        }
    }
}
